/**
 * MIME types of various file extensions used in loading.
 */
const MimeTypes = new Map();

MimeTypes.set("none", "application/octet-stream");

MimeTypes.set("bmp", "image/bmp");
MimeTypes.set("gif", "image/gif");
MimeTypes.set("jpg", "image/jpg");
MimeTypes.set("jpeg", "image/jpeg");
MimeTypes.set("png", "image/png");

MimeTypes.set("mp3", "audio/mpeg");
MimeTypes.set("ogg", "audio/ogg");
MimeTypes.set("wav", "audio/wav");
MimeTypes.set("flac", "audio/flac");

export default MimeTypes;
